import { Box, styled } from '@mui/material'

export const FlexBoxFullHeight = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
}))
